import { Component, OnInit } from '@angular/core';
import { FlashController } from 'src/app/flash-payment/flash-payment-core/services/flash-controller.service';

@Component({
  selector: 'app-ach-summary',
  templateUrl: './ach-summary.component.html',
  styleUrls: ['../payment-summary.component.sass']
})
export class AchSummaryComponent implements OnInit {

  constructor(public flashPaymentService: FlashController) { }

  ngOnInit(): void {
  }

}
